import { render, staticRenderFns } from "./GroupRequestItem.vue?vue&type=template&id=5ca0b1e6"
import script from "./GroupRequestItem.vue?vue&type=script&lang=js"
export * from "./GroupRequestItem.vue?vue&type=script&lang=js"
import style0 from "./GroupRequestItem.vue?vue&type=style&index=0&id=5ca0b1e6&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports